import { themeVariables } from "Components/theme";
import chroma from "chroma-js";
import classNames from "classnames";
import includes from "lodash/includes";
import startsWith from "lodash/startsWith";
import React, { memo, useMemo } from "react";
import AREA from "./area";
function ColorStyledBlock(props) {
    const color = useMemo(() => startsWith(props.color, "#")
        ? props.color
        : themeVariables[props.color || "table-border-color"], [props.color]);
    const bg = useMemo(() => props.bg && (startsWith(props.bg, "#") ? props.bg : themeVariables[props.bg]), [props.bg]);
    const border = useMemo(() => props.border && (startsWith(props.border, "#") ? props.border : themeVariables[props.border]), [props.border]);
    const style = useMemo(() => ({
        ...(props.style || {}),
        gridAutoFlow: "column",
        borderRadius: themeVariables["border-radius-base"],
        border: border !== null && border !== void 0 ? border : (color && includes(props.areas, AREA.BORDER) ? `1px solid ${color}` : undefined),
        color: color && includes(props.areas, AREA.TEXT) ? color : undefined,
        backgroundColor: bg !== null && bg !== void 0 ? bg : (color && props.bgLightness && includes(props.areas, AREA.BACKGROUND)
            ? chroma(color).set("hsl.l", props.bgLightness).css()
            : undefined),
        height: props.height
    }), [props.style, color, props.areas]);
    return (React.createElement("div", { className: classNames("d-grid v-center-items justify-content-start", props.className), style: style, title: props.title }, props.children));
}
export default memo(ColorStyledBlock);
ColorStyledBlock.defaultProps = {
    areas: [AREA.BORDER, AREA.TEXT],
    bgLightness: 0.95
};
